<template>
  <template-layout :breadCrumbList="breadcrumbComputed">

    <div class="grid grid-cols-12">
      <div class="col-span-12 lg:col-span-4 py-5 lg:py-12 px-4 text-grey-custom" style="font-size: .75rem">
        <nav class="flex justify-between items-center mb-2">
          <h1 class="text-lg text-theme-1 font-semibold">
            ภาพรวม<br />ครัวเรือนที่ประสบปัญหา
          </h1>
        </nav>
        <p class="text-xs text-theme-1">
          ข้อมูล ณ วันที่ {{ dateFormat(msoData.total.date, 'dd/MM/yyyy') }}
        </p>
        <doughnutChartHouseHoldProb v-if="1" :key="houseHoldProbKey" :houseHoldProb="msoData"
          :prefixAmount="prefixAmount" />
        <p class="font-semibold">จาก{{ prefixAmount }}ทั้งหมด {{ millionShortNum(msoData.total.total_survey) + ' ' +
        millionShortString(msoData.total.total_survey) + prefixAmount
        }}</p>
        <hr style="margin: .7rem 0px; height:1.5px;border-width:0;color:white;background-color:white">
        <p class="font-semibold">มิติที่ประสบปัญหา</p>
        <table class="w-full mt-3">
          <tr>
            <td style="min-width: 10px"><span
                style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#f8a436"></span>
            </td>
            <td>สุขภาพ</td>
            <td style="text-align: right">{{ millionShortNum(msoData.total.prob_health) }}</td>
            <td style="text-align: right">{{ millionShortString(msoData.total.prob_health) + prefixAmount
            }}</td>
          </tr>
          <tr>
            <td style="min-width: 10px"><span
                style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#f68c96"></span>
            </td>
            <td>ความเป็นอยู่</td>
            <td style="text-align: right">{{ millionShortNum(msoData.total.prob_family) }}</td>
            <td style="text-align: right">{{ millionShortString(msoData.total.prob_family) + prefixAmount
            }}</td>
          </tr>
          <tr>
            <td style="min-width: 10px"><span
                style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#7bc573"></span>
            </td>
            <td>การศึกษา</td>
            <td style="text-align: right">{{ millionShortNum(msoData.total.prob_education) }}</td>
            <td style="text-align: right">{{ millionShortString(msoData.total.prob_education) +
            prefixAmount
            }}</td>
          </tr>
          <tr>
            <td style="min-width: 10px"><span
                style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#76c9fa"></span>
            </td>
            <td>รายได้</td>
            <td style="text-align: right">{{ millionShortNum(msoData.total.prob_occupation) }}</td>
            <td style="text-align: right">{{ millionShortString(msoData.total.prob_occupation) +
            prefixAmount
            }}</td>
          </tr>
          <tr>
            <td style="min-width: 10px"><span
                style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#a984fa"></span>
            </td>
            <td>การเข้าถึงบริการรัฐ</td>
            <td style="text-align: right">{{ millionShortNum(msoData.total.prob_accessibility) }}</td>
            <td style="text-align: right">{{ millionShortString(msoData.total.prob_accessibility) +
            prefixAmount
            }}</td>
          </tr>
        </table>
        <p class="my-3 font-semibold">จำนวน{{ prefixAmount }}ที่ประสบปัญหา</p>
        <div class="grid grid-cols-5 gap-1" style="max-width: 250px; width:250px">
          <div class="col-span-1 text-center">
            <span class="my-4"
              style="display:inline-block;border-radius:20px;width:9px;height:9px;background-color:#8a9dca;"></span>
          </div>
          <div class="col-span-1 text-center">
            <span class="my-3"
              style="display:inline-block;border-radius:20px;width:16.25px;height:16.25px;background-color:#8a9dca"></span>
          </div>
          <div class="col-span-1 text-center">
            <span class="my-2"
              style="display:inline-block;border-radius:20px;width:22.5px;height:22.5px;background-color:#8a9dca"></span>
          </div>
          <div class="col-span-1 text-center">
            <span class="my-1"
              style="display:inline-block;border-radius:20px;width:28.75px;height:28.75px;background-color:#8a9dca"></span>
          </div>
          <div class="col-span-1 text-center">
            <span
              style="display:inline-block;border-radius:20px;width:35px;height:35px;background-color:#8a9dca"></span>
          </div>
          <!-- <div class="grid grid-cols-5 gap-1" style="max-width: 250px; width:250px">
            <div class="col-span-1 text-center">
              <p>x</p>
            </div>
            <div class="col-span-1 text-center">
              <p>x</p>
            </div>
            <div class="col-span-1 text-center">
              <p>x</p>
            </div>
            <div class="col-span-1 text-center">
              <p>x</p>
            </div>
            <div class="col-span-1 text-center">
              <p>x</p>
            </div>
          </div> -->
        </div>
        <p class="mt-4 mb-3 font-semibold">สัดส่วน{{ prefixAmount }}ที่ประสบปัญหา</p>
        <div class="relative">
          <hr class="absolute"
            style="margin: .7rem 0px; height:1px;border-width:0;color:#8a9dca;background-color:#8a9dca; width: calc(100% - 10px); top: -1.5px" />
          <span
            style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#8a9dca"></span>
          <span
            style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#8a9dca;margin-left: calc(100% - 30px)"></span>
          <span>1</span>
          <span style="margin-left: calc(100% - 26px)">100</span>
        </div>
      </div>

      <div id="mso_11_prov" class="col-span-12 lg:col-span-8 py-1 lg:py-5 px-0 mt-0 lg:mt-3"
        style="overflow-x: auto; overflow-y: hidden">
        <div class="mb-3" style="height: 50px">
          <div class="relative sm:absolute right-0 col-span-12 mr-5">
            <div class="grid grid-cols-2">
              <h3 class="col-end-auto text-md text-right mt-2 font-normal w-auto text-light-blue-custom">
                มุมมอง &nbsp;: &nbsp;&nbsp;
              </h3>
              <div class="col-auto flex rounded-lg border border-gray-300 overflow-hidden">
                <fieldset class="flex-grow text-center bg-white">
                  <input class="peer" type="radio" name="house_hold_view" id="view_1" value="1"
                    :disabled="apiLoad"
                    v-model="houseHoldView" />
                  <label
                    class="inline-block text-md w-full py-2 px-2 cursor-pointer text-theme-37 hover:bg-gray-100 peer-checked:bg-theme-2 peer-checked:text-white select-none"
                    for="view_1">ครัวเรือน</label>
                </fieldset>
                <fieldset class="flex-grow text-center border-l border-gray-300 bg-white">
                  <input class="peer" type="radio" name="house_hold_yiew" id="view_2" value="2"
                    :disabled="apiLoad"
                    v-model="houseHoldView" />
                  <label
                    class="inline-block text-md w-full py-2 px-2 cursor-pointer text-theme-37 hover:bg-gray-100 peer-checked:bg-theme-2 peer-checked:text-white select-none"
                    for="view_2">รายคน</label>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
        <div id="tooltip_custom_for_overflow"></div>

        <MSO :indexMSO="1" :prefixAmount="prefixAmount" :key="d1" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="2" :prefixAmount="prefixAmount" :key="d2" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="3" :prefixAmount="prefixAmount" :key="d3" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="4" :prefixAmount="prefixAmount" :key="d4" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="5" :prefixAmount="prefixAmount" :key="d5" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="6" :prefixAmount="prefixAmount" :key="d6" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="7" :prefixAmount="prefixAmount" :key="d7" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="8" :prefixAmount="prefixAmount" :key="d8" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="9" :prefixAmount="prefixAmount" :key="d9" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="10" :prefixAmount="prefixAmount" :key="d10" :msoData="msoData" :loadMSO="loadMSO" />
        <MSO :indexMSO="11" :prefixAmount="prefixAmount" :key="d11" :msoData="msoData" :loadMSO="loadMSO" />

      </div>
    </div>

    <!-- Follow stack barchart -->
    <div class="grid grid-cols-12 gap-3 bg-light-grey-custom mt-3 px-5 pt-5 pb-10">

      <div class="col-span-12 flex items-center text-gray-600 data-group mt-3 md:mt-0" data-test="data-level">
        <p class="text-md font-medium truncate mr-2">
          ระดับของข้อมูล :
        </p>
        <div class="w-80">
          <v-select class="bg-white" data-test="main-category" id="main-category-select" v-model="valueSelected"
            :options="options" :clearable="false" :searchable="true" placeholder="ระดับข้อมูล"
            @option:selecting="handleSelectedChange" @open="handleOpenDropdown">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <ChevronDownIcon class="w-5 h-5" />
              </span>
            </template>
          </v-select>
          <search-dropdown v-model="showDropdownFilter" class="rounded-md" :valueSelected="valueSelected"
            @click:cancel="handleClickCancel" @click:save="handleSearch"></search-dropdown>
        </div>
      </div>

      <div class="col-span-12 mt-1" v-if="valueSelected != 'ทั้งประเทศ'">
        <div class="flex">
          <p class="text-md font-medium truncate mr-2 text-gray-600">
            เงื่อนไขการค้นหา :
          </p>
          <i class="text-md">
            {{ searchResultText }}
          </i>
        </div>
      </div>

      <div class="col-span-12 lg:col-span-8 report-box-2 intro-y">
        <div class="box sm:flex h-full">
          <div class="p-4 w-full">
            <p class="w-full font-semibold text-left mb-3 text-blue-custom">การติดตามการแก้ไขปัญหาแยกตามมิติ</p>
            <div class="grid grid-cols-12">
              <div class="col-span-12 lg:col-span-6 relative">
                <div v-show="loadFollowResult" style="position: absolute; width: 100%; height:100%; background-color: #FFF; z-index:99;">
                  <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                    <LoadingIcon icon="three-dots" class="loading-icon" />
                  </div>
                </div>
                <stack5DimFollowResult :key="dimFollowResultKey" :DimFollow="resultImport" />
                <p class="text-center text-grey-custom font-light mt-3">แยกตามผลการติดตาม</p>
              </div>
              <div class="col-span-12 lg:col-span-6 relative">
                <div v-show="loadFollowStatus" style="position: absolute; width: 100%; height:100%; background-color: #FFF; z-index:99;">
                  <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                    <LoadingIcon icon="three-dots" class="loading-icon" />
                  </div>
                </div>
                <stack5DimFollowStatus :key="dimFollowStatusKey" :DimFollow="statusImport" />
                <p class="text-center text-grey-custom font-light mt-3">แยกตามสถานะการติดตาม
                </p>
              </div>
            </div>
            <p class="w-full font-normal text-left mt-3 text-grey-custom">มิติของปัญหา</p>

            <div class="col-span-12 relative">
              <div v-show="loadFollowResult" style="position: absolute; width: 100%; height:100%; background-color: #FFF; z-index:99;">
                <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                  <LoadingIcon icon="three-dots" class="loading-icon" />
                </div>
              </div>
              <table class="w-full mt-2" style="font-size: .85rem; color: #728196; line-height: 1.5">
                <tr>
                  <td>
                    สุขภาพ
                  </td>
                  <td>
                    ความเป็นอยู่
                  </td>
                  <td>
                    การศึกษา
                  </td>
                  <td>
                    รายได้
                  </td>
                  <td>
                    การเข้าถึงบริการรัฐ
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_health) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_health) }} คน</small>
                  </td>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_family) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_family) }} คน</small>
                  </td>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_education) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_education) }} คน</small>
                  </td>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_occupation) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_occupation) }} คน</small>
                  </td>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_accessibility) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_accessibility) }} คน</small>
                  </td>
                </tr>
              </table>

            </div>

          </div>
        </div>
      </div>

      <div class="col-span-12 lg:col-span-4 report-box-2 intro-y">
        <div class="box sm:flex h-full">
          <div class="px-4 py-4 flex-1 flex flex-col justify-center relative">
            <p class="font-semibold text-left mb-3 text-blue-custom">สถานะการติดตามการแก้ไขปัญหา แยกตามช่วงวัย
            </p>
            <div class="grid grid-cols-12">
              <div class="col-span-12 relative">
                <div v-show="loadFollowAge" style="position: absolute; width: 100%; height:100%; background-color: #FFF; z-index:99;">
                  <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                    <LoadingIcon icon="three-dots" class="loading-icon" />
                  </div>
                </div>
                <stack5DimFollowAgeRange :key="dimFollowAgeRangeKey" :DimFollow="ageRangeImport" />
              </div>
            </div>
            <p class="font-normal text-left mb-1 mt-3 text-grey-custom">ช่วงวัย</p>

            <div class="col-span-12 relative">
              <div v-show="loadFollowAge" style="position: absolute; width: 100%; height:100%; background-color: #FFF; z-index:99;">
                <div class="absolute w-20 h-20 left-0 right-0 top-0 bottom-0 m-auto">
                  <LoadingIcon icon="three-dots" class="loading-icon" />
                </div>
              </div>
              <table class="table-auto mt-2" style="font-size: .85rem; line-height: 1.5; color: #728196">
                <tr>
                  <td>
                    <div class="t-tooltip cursor-pointer">
                      <span class="t-tooltip-text" style="margin-left: 0px;">
                        (0-6 ปี)
                      </span>
                      &nbsp;เด็กเล็ก
                    </div>
                  </td>
                  <td>
                    <div class="t-tooltip cursor-pointer">
                      <span class="t-tooltip-text" style="margin-left: 0px">
                        (6 ปีขึ้นไป - 12 ปี)
                      </span>
                      &nbsp;เด็ก
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_youngchild) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_youngchild) }} คน</small>
                  </td>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_child) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_child) }} คน</small>
                  </td>
                </tr>
                <div style="height: 8px"></div>
                <tr>
                  <td>
                    <div class="t-tooltip cursor-pointer">
                      <span class="t-tooltip-text" style="margin-left: 0px">
                        (12 ปีขึ้นไป - 18 ปี)
                      </span>
                      &nbsp;เยาวชน
                    </div>
                  </td>
                  <td>
                    <div class="t-tooltip cursor-pointer">
                      <span class="t-tooltip-text" style="margin-left: 0px">
                        (18 ปีขึ้นไป - 59 ปี)
                      </span>
                      &nbsp;วัยผู้ใหญ่
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_adolescence) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_adolescence) }} คน</small>
                  </td>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_adult) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_adult) }} คน</small>
                  </td>
                </tr>
                <div style="height: 8px"></div>
                <tr>
                  <td>
                    <div class="t-tooltip cursor-pointer">
                      <span class="t-tooltip-text" style="margin-left: 0px">
                        (60 ปีขึ้นไป)
                      </span>
                      &nbsp;ผู้สูงอายุ
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="text-blue-custom">{{ globalNumDecFixed(ratio_elderly) }} %</span>
                    <small>&nbsp;&nbsp;/ &nbsp;{{ globalNumDecFixed(amount_elderly) }} คน</small>
                  </td>
                </tr>
              </table>
            </div>

          </div>
        </div>
      </div>

    </div>

  </template-layout>
</template>

<script setup>
import axios from "axios"
import { ref, computed, watch, reactive } from "vue";
import { useStore } from "vuex";

import TemplateLayout from "@/layouts/side-menu/Main.vue";
import MSO from "@/components/d3/mso.vue";
import doughnutChartHouseHoldProb from "@/components/echart/each_mso/doughnutChartHouseHoldProb.vue";
import stack5DimFollowStatus from "@/components/echart/each_mso/stack5DimFollowStatus.vue";
import stack5DimFollowResult from "@/components/echart/each_mso/stack5DimFollowResult.vue";
import stack5DimFollowAgeRange from "@/components/echart/each_mso/stack5DimFollowAgeRange.vue";
import searchDropdown from "@/views/landing-page/container/searchDropdownHouseHold.vue"

// all data from api
import problemHouseholdImport from "../../assets/json/problem_household/1_all_province_5dim_donut_edit2.json";
import resultImport1 from "../../assets/json/problem_household/2_result_stackbarchart.json";
import statusImport1 from "../../assets/json/problem_household/3_status_stackbarchart.json";
import ageRangeImport1 from "../../assets/json/problem_household/4_agerange_stackbarchart.json";
import resultImport2 from "../../assets/json/problem_household/2_result_stackbarchart_2.json";
import statusImport2 from "../../assets/json/problem_household/3_status_stackbarchart_2.json";
import ageRangeImport2 from "../../assets/json/problem_household/4_agerange_stackbarchart_2.json";

const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["householdFilter/getFilterSummaryArray"]
);

const filterValue = computed(() => store.getters["householdFilter/getFilterForApi"]);

const addHouseholdModal = ref(false);
const reloadTable = ref(false);
let houseHoldView = ref(1);
let prefixAmount = ref("ครัวเรือน");

// loading chart
let loadFollowResult = ref(false);
let loadFollowStatus = ref(false);
let loadFollowAge = ref(false);
let loadMSO = ref(false);

let resultImport = ref({
    "prob_health": {
        "survivable": 0,
        "sufficient": 0,
        "sustainable": 0,
        "not_proceeded": 0
    },
    "prob_family": {
        "survivable": 0,
        "sufficient": 0,
        "sustainable": 0,
        "not_proceeded": 0
    },
    "prob_education": {
        "survivable": 0,
        "sufficient": 0,
        "sustainable": 0,
        "not_proceeded": 0
    },
    "prob_occupation": {
        "survivable": 0,
        "sufficient": 0,
        "sustainable": 0,
        "not_proceeded": 0
    },
    "prob_accessibility": {
        "survivable": 0,
        "sufficient": 0,
        "sustainable": 0,
        "not_proceeded": 0
    }
});
let statusImport = ref({
    "prob_health": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    },
    "prob_family": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    },
    "prob_education": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    },
    "prob_occupation": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    },
    "prob_accessibility": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    }
});
let ageRangeImport = ref({
    "youngchild": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    },
    "child": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    },
    "adolescence": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    },
    "adult": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    },
    "elderly": {
        "closed": 0,
        "helped": 0,
        "planned": 0,
        "not_proceeded": 0
    }
});
// let msoData = problemHouseholdImport;
let msoDataDefault = {
  "total": {
      "date": "2022-12-27T04:56:00.889Z",
      "total_survey": 0,
      "total_prob": 0,
      "prob_health": 0,
      "prob_family": 0,
      "prob_education": 0,
      "prob_occupation": 0,
      "prob_accessibility": 0
  },
  "osm_province_list": {
    "osm_1": [],
    "osm_2": [],
    "osm_3": [],
    "osm_4": [],
    "osm_5": [],
    "osm_6": [],
    "osm_7": [],
    "osm_8": [],
    "osm_9": [],
    "osm_10": [],
    "osm_11": [],
    "osm_12": [],
  }
}
let msoData = ref({
  "total": {
      "date": "2022-12-27T04:56:00.889Z",
      "total_survey": 0,
      "total_prob": 0,
      "prob_health": 0,
      "prob_family": 0,
      "prob_education": 0,
      "prob_occupation": 0,
      "prob_accessibility": 0
  },
  "osm_province_list": {
    "osm_1": [],
    "osm_2": [],
    "osm_3": [],
    "osm_4": [],
    "osm_5": [],
    "osm_6": [],
    "osm_7": [],
    "osm_8": [],
    "osm_9": [],
    "osm_10": [],
    "osm_11": [],
    "osm_12": [],
  }
});
let d1 = ref(1);
let d2 = ref(1);
let d3 = ref(1);
let d4 = ref(1);
let d5 = ref(1);
let d6 = ref(1);
let d7 = ref(1);
let d8 = ref(1);
let d9 = ref(1);
let d10 = ref(1);
let d11 = ref(1);

let dimFollowResultKey = ref(1);
let dimFollowStatusKey = ref(1);
let dimFollowAgeRangeKey = ref(1);
let houseHoldProbKey = ref(1);

const selectState = ref('firstOptionValue');
const valueSelected = ref('ทั้งประเทศ');
const options = reactive(['ทั้งประเทศ', 'สำนักงานส่งเสริมและสนับสนุนวิชาการ', 'จังหวัด']);
const showModal = ref(false);
const searchResult = ref(null);
const showDropdownFilter = ref(false);
const searchResultText = ref(null);
const num_state_change = ref(1);

let amount_health = ref(0);
let amount_family = ref(0);
let amount_education = ref(0);
let amount_occupation = ref(0);
let amount_accessibility = ref(0);

let ratio_health = ref(0);
let ratio_family = ref(0);
let ratio_education = ref(0);
let ratio_occupation = ref(0);
let ratio_accessibility = ref(0);

let amount_youngchild = ref(0);
let amount_child = ref(0);
let amount_adolescence = ref(0);
let amount_adult = ref(0);
let amount_elderly = ref(0);

let ratio_youngchild = ref(0);
let ratio_child = ref(0);
let ratio_adolescence = ref(0);
let ratio_adult = ref(0);
let ratio_elderly = ref(0);

let apiLoad = ref(false);

const openAddHouseholdModal = (val) => {
  addHouseholdModal.value = val;
  reloadTable.value = false;
};
const clearValue = (val) => {
  addHouseholdModal.value = false;
  reloadTable.value = val == "saved" ? true : false;
};

var globalNumDecFixed = (num, dec_amount) => {
  if (!(num % 1)) {
    dec_amount = 0;
  }
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: dec_amount,
  }).format(Number.parseFloat(num).toFixed(dec_amount));
};

var millionShortNum = (num) => {
  if (num >= 1000000000000000000000000) {
    return globalNumDecFixed(
      (num / 1000000000000000000000000).toFixed(2).replace(/\.0$/, ""),
      2
    );
  }else if (num >= 1000000000000000000) {
    return globalNumDecFixed(
      (num / 1000000000000000000).toFixed(2).replace(/\.0$/, ""),
      2
    );
  }else if (num >= 1000000000000) {
    return globalNumDecFixed((num / 1000000000000)
      .toFixed(2)
      .replace(/\.0$/, ""), 2);
  }else if (num >= 1000000) {
    return globalNumDecFixed((num / 1000000)
      .toFixed(2)
      .replace(/\.0$/, ""), 2);
  }else if (num < 1000000) {
    // return globalNumDecFixed((num / 1000000)
    //   .toFixed(2)
    //   .replace(/\.0$/, ""), 3);
  }
  return globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 2);
};

var millionShortString = (num) => {
  if (num >= 1000000000000000000000000) {
    return "ล้านล้านล้านล้าน";
  }
  if (num >= 1000000000000000000) {
    return "ล้านล้านล้าน";
  }
  if (num >= 1000000000000) {
    return "ล้านล้าน";
  }
  if (num >= 1000000) {
    return "ล้าน";
  }
  return '';
};

const dateFormat = (inputDate, format) => {
  const date = new Date(inputDate);

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear() + 543;

  format = format.replace("MM", month.toString().padStart(2, "0"));

  if (format.indexOf("yyyy") > -1) {
    format = format.replace("yyyy", year.toString());
  } else if (format.indexOf("yy") > -1) {
    format = format.replace("yy", year.toString().substr(2, 2));
  }

  format = format.replace("dd", day.toString().padStart(2, "0"));

  return format;
}

const breadcrumbComputed = reactive([
  {
    name: "ครัวเรือนที่ประสบปัญหา",
    active: true,
  },
]);

watch(
  houseHoldView,
  (first, second) => {
    if(!apiLoad.value){
      if (first == 1) {
        prefixAmount.value = "ครัวเรือน";
      } else {
        prefixAmount.value = "คน";
      }
      console.log("view change to "+prefixAmount.value );
      getMemberDonutChartStats();
    }
  }
);

watch(
  searchResultText,
  (first, second) => {
    console.log('test watch text !!!');
    if (first != second) {
      if (num_state_change.value == 1) {

        // statusImport = statusImport2;
        // ageRangeImport = ageRangeImport2;
        // resultImport = resultImport2;
        // dimFollowResultKey.value++;
        // dimFollowStatusKey.value++;
        // dimFollowAgeRangeKey.value++;

        getMemberStackBarChartStats();
        getMemberStackBarChartActionStats();
        getMemberStackBarChartAgeClassStats();

        houseHoldProbKey.value++;
        // console.log('searchResultText change 1');
        // console.log(dimFollowResultKey.value);
        // console.log(num_state_change.value);
        num_state_change.value = 2;

      } else {

        // statusImport = statusImport1;
        // ageRangeImport = ageRangeImport1;
        // resultImport = resultImport1;
        // dimFollowResultKey.value++;
        // dimFollowStatusKey.value++;
        // dimFollowAgeRangeKey.value++;

        getMemberStackBarChartStats();
        getMemberStackBarChartActionStats();
        getMemberStackBarChartAgeClassStats();

        houseHoldProbKey.value++;
        // console.log('searchResultText change 2');
        // console.log(dimFollowResultKey.value);
        // console.log(num_state_change.value);
        num_state_change.value = 1;

      }
    }
  }
);

const handleModal = (val) => {//when select change show modal
  if (val == "สำนักงานส่งเสริมและสนับสนุนวิชาการ" || val == "จังหวัด") {
    showModal.value = !showModal.value
  }
}
const handleSelectedChange = (val) => {
  console.log("handleSelectedChange");
  if (val == "สำนักงานส่งเสริมและสนับสนุนวิชาการ" || val == "จังหวัด") {
    showDropdownFilter.value = !showDropdownFilter.value
  }else{
    store.commit('householdFilter/setOSM', null)
    var address = {
      amphur: null,
      province: null,
      tumbol: null,
      village: null,
    };
    store.commit('householdFilter/setAddress', address)
    searchResultText.value = "ทั้งประเทศ";
  }
}
const handleClickCancel = () => {
  console.log("handleClickCancel");
  valueSelected.value = "ทั้งประเทศ"
}
const handleOpenDropdown = () => {
  showDropdownFilter.value = false
}
const handleSearch = (val) => {
  console.log(val);
  let text = ""
  if (valueSelected.value == "จังหวัด" && val) {
    if (val.province) {

      var address = {};

      text += "จังหวัด" + val.province.province_name
      address.province = val.province._id.province_ID
      // store.commit('setProvince', val.province.province_id);

      if (val.district) {
        text += " อำเภอ" + val.district.amphur_name
        address.amphur = val.district._id.amphur_ID
        // store.commit('setAmphur', val.district._id.amphur_ID);
      }
      if (val.subdistrict) {
        text += " ตำบล" + val.subdistrict.tumbol_name
        address.tumbol = val.subdistrict._id.tumbol_ID
        // store.commit('setTumbol', val.subdistrict._id.tumbol_ID);
      }
      if (val.village) {
        text += " หมู่บ้าน" + val.village.village_name
        address.village = val.village._id.village_ID
        // store.commit('setVillage', val.village._id.village_ID);
      }
      store.commit('householdFilter/setAddress', address)
      store.commit('householdFilter/setOSM', null)
    }
    searchResultText.value = text;
  }
  else {
    if (val.organize) {
      searchResultText.value = val.organize
      // how to get id form organize;
      var osm = val.organize;
      var _osm = osm.split(" ");
      var osm_id = _osm[1];
      store.commit('householdFilter/setOSM', osm_id)
      // reset province select
      var address = {
        amphur: null,
        province: null,
        tumbol: null,
        village: null,
      };
      store.commit('householdFilter/setAddress', address)
    }
  }
}

const getParams = () => {
    var params = {};

    if (valueSelected.value == "จังหวัด") {

      if (store.state.householdFilter.address.province && store.state.householdFilter.address.province != 0) {
          var txt = store.state.householdFilter.address.province
          params.prov = txt.toString();
      }
      if (store.state.householdFilter.address.amphur && store.state.householdFilter.address.amphur != 0) {
          var txt = store.state.householdFilter.address.amphur
          params.amp = txt.toString();
      }
      if (store.state.householdFilter.address.tumbol && store.state.householdFilter.address.tumbol != 0) {
          var txt = store.state.householdFilter.address.tumbol
          params.tam = txt.toString();
      }

    }else{

      if (store.state.householdFilter.osm && store.state.householdFilter.osm != 0) {
          var txt = store.state.householdFilter.osm
          params.osm = txt.toString();
      }

    }
    return params;
}

const getMemberDonutChartStats = () => {

  let param = {};
  if (prefixAmount.value == "คน") {
    param = { "group_by":"member" }
  } else {
    param = { "group_by":"household" }
  }

  try {

    //reset data
    msoData.value = msoDataDefault;
    apiLoad.value = true;

    loadMSO.value = true;
    axios.post(`${process.env.VUE_APP_BASE_API}member/getMemberDonutChartStats`, param)
    .then((response) => {

      // console.log(response.data);
      loadMSO.value = false;
      apiLoad.value = false;
      msoData.value = response.data;
      d1.value++;
      d2.value++;
      d3.value++;
      d4.value++;
      d5.value++;
      d6.value++;
      d7.value++;
      d8.value++;
      d9.value++;
      d10.value++;
      d11.value++;

    })
  } catch (error) {
    console.log(error.message);
  }

  /*try {
    loadMSO.value = true;
    msoData.value = {
        "total": {
            "date": "2022-12-27T10:43:59.558Z",
            "total_survey": 563671,
            "total_prob": 235059,
            "prob_health": 30116,
            "prob_family": 100785,
            "prob_education": 20711,
            "prob_occupation": 201296,
            "prob_accessibility": 8695
        },
        "osm_province_list": {
            "osm_1": [
                {
                    "total_survey": 3539,
                    "province_name": "สระบุรี",
                    "total_prob": 1419,
                    "prob_health": 395,
                    "prob_family": 966,
                    "prob_education": 73,
                    "prob_occupation": 1220,
                    "prob_accessibility": 17,
                    "province_ID": "19"
                },
                {
                    "total_survey": 3208,
                    "province_name": "นครนายก",
                    "total_prob": 1575,
                    "prob_health": 99,
                    "prob_family": 502,
                    "prob_education": 24,
                    "prob_occupation": 1331,
                    "prob_accessibility": 7,
                    "province_ID": "26"
                },
                {
                    "total_survey": 7159,
                    "province_name": "สมุทรปราการ",
                    "total_prob": 1483,
                    "prob_health": 21,
                    "prob_family": 1349,
                    "prob_education": 79,
                    "prob_occupation": 591,
                    "prob_accessibility": 1,
                    "province_ID": "11"
                },
                {
                    "total_survey": 4,
                    "province_name": "กรุงเทพมหานคร",
                    "total_prob": 4,
                    "prob_health": 2,
                    "prob_family": 3,
                    "prob_education": 2,
                    "prob_occupation": 3,
                    "prob_accessibility": 1,
                    "province_ID": "10"
                },
                {
                    "total_survey": 2227,
                    "province_name": "ปทุมธานี",
                    "total_prob": 709,
                    "prob_health": 203,
                    "prob_family": 449,
                    "prob_education": 38,
                    "prob_occupation": 551,
                    "prob_accessibility": 17,
                    "province_ID": "13"
                },
                {
                    "total_survey": 6769,
                    "province_name": "อ่างทอง",
                    "total_prob": 3025,
                    "prob_health": 700,
                    "prob_family": 2041,
                    "prob_education": 244,
                    "prob_occupation": 2888,
                    "prob_accessibility": 54,
                    "province_ID": "14"
                },
                {
                    "total_survey": 6896,
                    "province_name": "พระนครศรีอยุธยา",
                    "total_prob": 2396,
                    "prob_health": 468,
                    "prob_family": 1541,
                    "prob_education": 102,
                    "prob_occupation": 1471,
                    "prob_accessibility": 56,
                    "province_ID": "14"
                },
                {
                    "total_survey": 4257,
                    "province_name": "นนทบุรี",
                    "total_prob": 899,
                    "prob_health": 272,
                    "prob_family": 611,
                    "prob_education": 35,
                    "prob_occupation": 804,
                    "prob_accessibility": 62,
                    "province_ID": "12"
                }
            ],
            "osm_2": [
                {
                    "total_survey": 10547,
                    "province_name": "ปราจีนบุรี",
                    "total_prob": 3001,
                    "prob_health": 1070,
                    "prob_family": 458,
                    "prob_education": 122,
                    "prob_occupation": 2027,
                    "prob_accessibility": 19,
                    "province_ID": "25"
                },
                {
                    "total_survey": 8257,
                    "province_name": "ชลบุรี",
                    "total_prob": 1784,
                    "prob_health": 234,
                    "prob_family": 470,
                    "prob_education": 47,
                    "prob_occupation": 1733,
                    "prob_accessibility": 27,
                    "province_ID": "20"
                },
                {
                    "total_survey": 6799,
                    "province_name": "จันทบุรี",
                    "total_prob": 5469,
                    "prob_health": 455,
                    "prob_family": 4240,
                    "prob_education": 75,
                    "prob_occupation": 3620,
                    "prob_accessibility": 45,
                    "province_ID": "22"
                },
                {
                    "total_survey": 4385,
                    "province_name": "ระยอง",
                    "total_prob": 696,
                    "prob_health": 64,
                    "prob_family": 440,
                    "prob_education": 59,
                    "prob_occupation": 656,
                    "prob_accessibility": 14,
                    "province_ID": "21"
                },
                {
                    "total_survey": 4358,
                    "province_name": "สระแก้ว",
                    "total_prob": 2496,
                    "prob_health": 553,
                    "prob_family": 1652,
                    "prob_education": 263,
                    "prob_occupation": 2251,
                    "prob_accessibility": 63,
                    "province_ID": "27"
                },
                {
                    "total_survey": 3281,
                    "province_name": "ตราด",
                    "total_prob": 1075,
                    "prob_health": 213,
                    "prob_family": 362,
                    "prob_education": 19,
                    "prob_occupation": 899,
                    "prob_accessibility": 70,
                    "province_ID": "23"
                },
                {
                    "total_survey": 6273,
                    "province_name": "ฉะเชิงเทรา",
                    "total_prob": 814,
                    "prob_health": 288,
                    "prob_family": 589,
                    "prob_education": 39,
                    "prob_occupation": 759,
                    "prob_accessibility": 42,
                    "province_ID": "24"
                }
            ],
            "osm_3": [
                {
                    "total_survey": 1775,
                    "province_name": "สมุทรสงคราม",
                    "total_prob": 597,
                    "prob_health": 70,
                    "prob_family": 135,
                    "prob_education": 9,
                    "prob_occupation": 305,
                    "prob_accessibility": 227,
                    "province_ID": "75"
                },
                {
                    "total_survey": 7559,
                    "province_name": "กาญจนบุรี",
                    "total_prob": 4062,
                    "prob_health": 1106,
                    "prob_family": 1475,
                    "prob_education": 1101,
                    "prob_occupation": 2810,
                    "prob_accessibility": 135,
                    "province_ID": "71"
                },
                {
                    "total_survey": 3479,
                    "province_name": "สมุทรสาคร",
                    "total_prob": 1028,
                    "prob_health": 491,
                    "prob_family": 342,
                    "prob_education": 67,
                    "prob_occupation": 667,
                    "prob_accessibility": 6,
                    "province_ID": "74"
                },
                {
                    "total_survey": 3800,
                    "province_name": "ราชบุรี",
                    "total_prob": 2685,
                    "prob_health": 658,
                    "prob_family": 1549,
                    "prob_education": 267,
                    "prob_occupation": 2544,
                    "prob_accessibility": 37,
                    "province_ID": "70"
                },
                {
                    "total_survey": 9270,
                    "province_name": "นครปฐม",
                    "total_prob": 2446,
                    "prob_health": 292,
                    "prob_family": 840,
                    "prob_education": 605,
                    "prob_occupation": 2192,
                    "prob_accessibility": 146,
                    "province_ID": "73"
                },
                {
                    "total_survey": 8706,
                    "province_name": "สุพรรณบุรี",
                    "total_prob": 4774,
                    "prob_health": 635,
                    "prob_family": 1654,
                    "prob_education": 410,
                    "prob_occupation": 4557,
                    "prob_accessibility": 35,
                    "province_ID": "72"
                },
                {
                    "total_survey": 4139,
                    "province_name": "ประจวบคีรีขันธ์",
                    "total_prob": 2702,
                    "prob_health": 1150,
                    "prob_family": 1157,
                    "prob_education": 77,
                    "prob_occupation": 2459,
                    "prob_accessibility": 40,
                    "province_ID": "77"
                },
                {
                    "total_survey": 5696,
                    "province_name": "เพชรบุรี",
                    "total_prob": 807,
                    "prob_health": 120,
                    "prob_family": 409,
                    "prob_education": 50,
                    "prob_occupation": 795,
                    "prob_accessibility": 8,
                    "province_ID": "76"
                }
            ],
            "osm_4": [
                {
                    "total_survey": 10655,
                    "province_name": "ศรีสะเกษ",
                    "total_prob": 615,
                    "prob_health": 24,
                    "prob_family": 580,
                    "prob_education": 115,
                    "prob_occupation": 597,
                    "prob_accessibility": 11,
                    "province_ID": "33"
                },
                {
                    "total_survey": 30480,
                    "province_name": "นครราชสีมา",
                    "total_prob": 815,
                    "prob_health": 350,
                    "prob_family": 499,
                    "prob_education": 65,
                    "prob_occupation": 760,
                    "prob_accessibility": 51,
                    "province_ID": "30"
                },
                {
                    "total_survey": 6962,
                    "province_name": "ยโสธร",
                    "total_prob": 4499,
                    "prob_health": 979,
                    "prob_family": 3561,
                    "prob_education": 993,
                    "prob_occupation": 4054,
                    "prob_accessibility": 25,
                    "province_ID": "35"
                },
                {
                    "total_survey": 6106,
                    "province_name": "บุรีรัมย์",
                    "total_prob": 567,
                    "prob_health": 58,
                    "prob_family": 478,
                    "prob_education": 72,
                    "prob_occupation": 376,
                    "prob_accessibility": 8,
                    "province_ID": "31"
                },
                {
                    "total_survey": 7152,
                    "province_name": "ชัยภูมิ",
                    "total_prob": 5432,
                    "prob_health": 613,
                    "prob_family": 2108,
                    "prob_education": 324,
                    "prob_occupation": 4906,
                    "prob_accessibility": 69,
                    "province_ID": "36"
                },
                {
                    "total_survey": 8905,
                    "province_name": "สุรินทร์",
                    "total_prob": 738,
                    "prob_health": 142,
                    "prob_family": 485,
                    "prob_education": 50,
                    "prob_occupation": 701,
                    "prob_accessibility": 138,
                    "province_ID": "32"
                }
            ],
            "osm_5": [
                {
                    "total_survey": 5400,
                    "province_name": "หนองบัวลำภู",
                    "total_prob": 4640,
                    "prob_health": 144,
                    "prob_family": 1189,
                    "prob_education": 26,
                    "prob_occupation": 3943,
                    "prob_accessibility": 37,
                    "province_ID": "39"
                },
                {
                    "total_survey": 11779,
                    "province_name": "มหาสารคาม",
                    "total_prob": 101,
                    "prob_health": 13,
                    "prob_family": 62,
                    "prob_education": 15,
                    "prob_occupation": 98,
                    "prob_accessibility": 0,
                    "province_ID": "44"
                },
                {
                    "total_survey": 11733,
                    "province_name": "ร้อยเอ็ด",
                    "total_prob": 2673,
                    "prob_health": 521,
                    "prob_family": 2202,
                    "prob_education": 407,
                    "prob_occupation": 2398,
                    "prob_accessibility": 75,
                    "province_ID": "45"
                },
                {
                    "total_survey": 6563,
                    "province_name": "ขอนแก่น",
                    "total_prob": 1467,
                    "prob_health": 282,
                    "prob_family": 934,
                    "prob_education": 146,
                    "prob_occupation": 841,
                    "prob_accessibility": 516,
                    "province_ID": "40"
                },
                {
                    "total_survey": 15072,
                    "province_name": "อุดรธานี",
                    "total_prob": 833,
                    "prob_health": 89,
                    "prob_family": 676,
                    "prob_education": 54,
                    "prob_occupation": 813,
                    "prob_accessibility": 19,
                    "province_ID": "41"
                },
                {
                    "total_survey": 9231,
                    "province_name": "เลย",
                    "total_prob": 5936,
                    "prob_health": 363,
                    "prob_family": 2212,
                    "prob_education": 428,
                    "prob_occupation": 5005,
                    "prob_accessibility": 51,
                    "province_ID": "42"
                },
                {
                    "total_survey": 6488,
                    "province_name": "หนองคาย",
                    "total_prob": 1231,
                    "prob_health": 150,
                    "prob_family": 515,
                    "prob_education": 64,
                    "prob_occupation": 1070,
                    "prob_accessibility": 44,
                    "province_ID": "43"
                }
            ],
            "osm_6": [
                {
                    "total_survey": 6880,
                    "province_name": "กาฬสินธุ์",
                    "total_prob": 3819,
                    "prob_health": 448,
                    "prob_family": 2013,
                    "prob_education": 330,
                    "prob_occupation": 3643,
                    "prob_accessibility": 54,
                    "province_ID": "46"
                },
                {
                    "total_survey": 3435,
                    "province_name": "บึงกาฬ",
                    "total_prob": 2427,
                    "prob_health": 246,
                    "prob_family": 612,
                    "prob_education": 315,
                    "prob_occupation": 2305,
                    "prob_accessibility": 10,
                    "province_ID": "38"
                },
                {
                    "total_survey": 4487,
                    "province_name": "อำนาจเจริญ",
                    "total_prob": 434,
                    "prob_health": 79,
                    "prob_family": 179,
                    "prob_education": 69,
                    "prob_occupation": 403,
                    "prob_accessibility": 5,
                    "province_ID": "37"
                },
                {
                    "total_survey": 6900,
                    "province_name": "มุกดาหาร",
                    "total_prob": 4267,
                    "prob_health": 131,
                    "prob_family": 2792,
                    "prob_education": 357,
                    "prob_occupation": 3467,
                    "prob_accessibility": 28,
                    "province_ID": "49"
                },
                {
                    "total_survey": 6739,
                    "province_name": "สกลนคร",
                    "total_prob": 2678,
                    "prob_health": 73,
                    "prob_family": 2082,
                    "prob_education": 1278,
                    "prob_occupation": 1629,
                    "prob_accessibility": 25,
                    "province_ID": "47"
                },
                {
                    "total_survey": 17352,
                    "province_name": "อุบลราชธานี",
                    "total_prob": 13459,
                    "prob_health": 1967,
                    "prob_family": 596,
                    "prob_education": 2085,
                    "prob_occupation": 7712,
                    "prob_accessibility": 4035,
                    "province_ID": "34"
                },
                {
                    "total_survey": 5743,
                    "province_name": "นครพนม",
                    "total_prob": 4007,
                    "prob_health": 399,
                    "prob_family": 1312,
                    "prob_education": 586,
                    "prob_occupation": 3799,
                    "prob_accessibility": 40,
                    "province_ID": "48"
                }
            ],
            "osm_7": [
                {
                    "total_survey": 4848,
                    "province_name": "ชัยนาท",
                    "total_prob": 3565,
                    "prob_health": 121,
                    "prob_family": 1545,
                    "prob_education": 14,
                    "prob_occupation": 2802,
                    "prob_accessibility": 17,
                    "province_ID": "18"
                },
                {
                    "total_survey": 5614,
                    "province_name": "พิจิตร",
                    "total_prob": 5272,
                    "prob_health": 646,
                    "prob_family": 3272,
                    "prob_education": 365,
                    "prob_occupation": 4205,
                    "prob_accessibility": 221,
                    "province_ID": "66"
                },
                {
                    "total_survey": 17754,
                    "province_name": "นครสวรรค์",
                    "total_prob": 1230,
                    "prob_health": 169,
                    "prob_family": 511,
                    "prob_education": 86,
                    "prob_occupation": 872,
                    "prob_accessibility": 13,
                    "province_ID": "60"
                },
                {
                    "total_survey": 3998,
                    "province_name": "อุทัยธานี",
                    "total_prob": 2846,
                    "prob_health": 1169,
                    "prob_family": 1634,
                    "prob_education": 253,
                    "prob_occupation": 2199,
                    "prob_accessibility": 15,
                    "province_ID": "61"
                },
                {
                    "total_survey": 3508,
                    "province_name": "ลพบุรี",
                    "total_prob": 1777,
                    "prob_health": 180,
                    "prob_family": 636,
                    "prob_education": 34,
                    "prob_occupation": 1522,
                    "prob_accessibility": 21,
                    "province_ID": "16"
                },
                {
                    "total_survey": 2142,
                    "province_name": "สิงห์บุรี",
                    "total_prob": 2134,
                    "prob_health": 177,
                    "prob_family": 656,
                    "prob_education": 3,
                    "prob_occupation": 1795,
                    "prob_accessibility": 9,
                    "province_ID": "17"
                }
            ],
            "osm_8": [
                {
                    "total_survey": 3203,
                    "province_name": "อุตรดิตถ์",
                    "total_prob": 1153,
                    "prob_health": 251,
                    "prob_family": 635,
                    "prob_education": 261,
                    "prob_occupation": 1040,
                    "prob_accessibility": 30,
                    "province_ID": "53"
                },
                {
                    "total_survey": 10228,
                    "province_name": "เพชรบูรณ์",
                    "total_prob": 6758,
                    "prob_health": 721,
                    "prob_family": 2890,
                    "prob_education": 699,
                    "prob_occupation": 6518,
                    "prob_accessibility": 51,
                    "province_ID": "67"
                },
                {
                    "total_survey": 6937,
                    "province_name": "ตาก",
                    "total_prob": 2136,
                    "prob_health": 134,
                    "prob_family": 653,
                    "prob_education": 520,
                    "prob_occupation": 2107,
                    "prob_accessibility": 110,
                    "province_ID": "63"
                },
                {
                    "total_survey": 7545,
                    "province_name": "พิษณุโลก",
                    "total_prob": 138,
                    "prob_health": 21,
                    "prob_family": 10,
                    "prob_education": 2,
                    "prob_occupation": 134,
                    "prob_accessibility": 0,
                    "province_ID": "65"
                },
                {
                    "total_survey": 6259,
                    "province_name": "สุโขทัย",
                    "total_prob": 1959,
                    "prob_health": 309,
                    "prob_family": 907,
                    "prob_education": 129,
                    "prob_occupation": 1630,
                    "prob_accessibility": 22,
                    "province_ID": "64"
                },
                {
                    "total_survey": 7085,
                    "province_name": "กำแพงเพชร",
                    "total_prob": 838,
                    "prob_health": 249,
                    "prob_family": 589,
                    "prob_education": 133,
                    "prob_occupation": 773,
                    "prob_accessibility": 32,
                    "province_ID": "62"
                }
            ],
            "osm_9": [
                {
                    "total_survey": 4026,
                    "province_name": "น่าน",
                    "total_prob": 2345,
                    "prob_health": 454,
                    "prob_family": 1122,
                    "prob_education": 251,
                    "prob_occupation": 2204,
                    "prob_accessibility": 42,
                    "province_ID": "55"
                },
                {
                    "total_survey": 6538,
                    "province_name": "เชียงราย",
                    "total_prob": 113,
                    "prob_health": 32,
                    "prob_family": 56,
                    "prob_education": 14,
                    "prob_occupation": 99,
                    "prob_accessibility": 2,
                    "province_ID": "57"
                },
                {
                    "total_survey": 11634,
                    "province_name": "เชียงใหม่",
                    "total_prob": 7910,
                    "prob_health": 900,
                    "prob_family": 6003,
                    "prob_education": 951,
                    "prob_occupation": 6427,
                    "prob_accessibility": 137,
                    "province_ID": "50"
                },
                {
                    "total_survey": 4998,
                    "province_name": "ลำพูน",
                    "total_prob": 2759,
                    "prob_health": 605,
                    "prob_family": 1848,
                    "prob_education": 470,
                    "prob_occupation": 2661,
                    "prob_accessibility": 65,
                    "province_ID": "51"
                },
                {
                    "total_survey": 4632,
                    "province_name": "แพร่",
                    "total_prob": 4043,
                    "prob_health": 997,
                    "prob_family": 1257,
                    "prob_education": 148,
                    "prob_occupation": 3933,
                    "prob_accessibility": 9,
                    "province_ID": "54"
                },
                {
                    "total_survey": 3305,
                    "province_name": "พะเยา",
                    "total_prob": 1880,
                    "prob_health": 708,
                    "prob_family": 1114,
                    "prob_education": 246,
                    "prob_occupation": 1603,
                    "prob_accessibility": 355,
                    "province_ID": "56"
                },
                {
                    "total_survey": 3358,
                    "province_name": "ลำปาง",
                    "total_prob": 2074,
                    "prob_health": 498,
                    "prob_family": 1480,
                    "prob_education": 369,
                    "prob_occupation": 1849,
                    "prob_accessibility": 107,
                    "province_ID": "52"
                },
                {
                    "total_survey": 2702,
                    "province_name": "แม่ฮ่องสอน",
                    "total_prob": 852,
                    "prob_health": 267,
                    "prob_family": 634,
                    "prob_education": 214,
                    "prob_occupation": 760,
                    "prob_accessibility": 48,
                    "province_ID": "58"
                }
            ],
            "osm_10": [
                {
                    "total_survey": 3084,
                    "province_name": "ภูเก็ต",
                    "total_prob": 2407,
                    "prob_health": 184,
                    "prob_family": 598,
                    "prob_education": 287,
                    "prob_occupation": 2133,
                    "prob_accessibility": 28,
                    "province_ID": "83"
                },
                {
                    "total_survey": 8327,
                    "province_name": "ชุมพร",
                    "total_prob": 6395,
                    "prob_health": 218,
                    "prob_family": 1597,
                    "prob_education": 451,
                    "prob_occupation": 6294,
                    "prob_accessibility": 17,
                    "province_ID": "86"
                },
                {
                    "total_survey": 25167,
                    "province_name": "นครศรีธรรมราช",
                    "total_prob": 20551,
                    "prob_health": 588,
                    "prob_family": 1826,
                    "prob_education": 122,
                    "prob_occupation": 20343,
                    "prob_accessibility": 67,
                    "province_ID": "80"
                },
                {
                    "total_survey": 4230,
                    "province_name": "ระนอง",
                    "total_prob": 3332,
                    "prob_health": 220,
                    "prob_family": 300,
                    "prob_education": 23,
                    "prob_occupation": 3156,
                    "prob_accessibility": 6,
                    "province_ID": "85"
                },
                {
                    "total_survey": 3847,
                    "province_name": "พังงา",
                    "total_prob": 1049,
                    "prob_health": 258,
                    "prob_family": 485,
                    "prob_education": 98,
                    "prob_occupation": 922,
                    "prob_accessibility": 27,
                    "province_ID": "82"
                },
                {
                    "total_survey": 24285,
                    "province_name": "สุราษฎร์ธานี",
                    "total_prob": 4233,
                    "prob_health": 705,
                    "prob_family": 964,
                    "prob_education": 88,
                    "prob_occupation": 3617,
                    "prob_accessibility": 53,
                    "province_ID": "84"
                },
                {
                    "total_survey": 8483,
                    "province_name": "กระบี่",
                    "total_prob": 6439,
                    "prob_health": 543,
                    "prob_family": 3275,
                    "prob_education": 555,
                    "prob_occupation": 5891,
                    "prob_accessibility": 253,
                    "province_ID": "81"
                }
            ],
            "osm_11": [
                {
                    "total_survey": 5583,
                    "province_name": "นราธิวาส",
                    "total_prob": 2907,
                    "prob_health": 236,
                    "prob_family": 1222,
                    "prob_education": 403,
                    "prob_occupation": 2690,
                    "prob_accessibility": 23,
                    "province_ID": "96"
                },
                {
                    "total_survey": 5640,
                    "province_name": "ปัตตานี",
                    "total_prob": 3072,
                    "prob_health": 189,
                    "prob_family": 2550,
                    "prob_education": 278,
                    "prob_occupation": 2471,
                    "prob_accessibility": 25,
                    "province_ID": "94"
                },
                {
                    "total_survey": 18387,
                    "province_name": "สงขลา",
                    "total_prob": 13980,
                    "prob_health": 664,
                    "prob_family": 5706,
                    "prob_education": 309,
                    "prob_occupation": 11608,
                    "prob_accessibility": 425,
                    "province_ID": "90"
                },
                {
                    "total_survey": 4105,
                    "province_name": "ยะลา",
                    "total_prob": 3033,
                    "prob_health": 283,
                    "prob_family": 1231,
                    "prob_education": 354,
                    "prob_occupation": 2662,
                    "prob_accessibility": 16,
                    "province_ID": "95"
                },
                {
                    "total_survey": 8773,
                    "province_name": "พัทลุง",
                    "total_prob": 256,
                    "prob_health": 91,
                    "prob_family": 125,
                    "prob_education": 35,
                    "prob_occupation": 199,
                    "prob_accessibility": 4,
                    "province_ID": "93"
                },
                {
                    "total_survey": 3206,
                    "province_name": "สตูล",
                    "total_prob": 1912,
                    "prob_health": 352,
                    "prob_family": 1053,
                    "prob_education": 474,
                    "prob_occupation": 1757,
                    "prob_accessibility": 19,
                    "province_ID": "91"
                },
                {
                    "total_survey": 9794,
                    "province_name": "ตรัง",
                    "total_prob": 7127,
                    "prob_health": 347,
                    "prob_family": 4080,
                    "prob_education": 486,
                    "prob_occupation": 6767,
                    "prob_accessibility": 56,
                    "province_ID": "92"
                }
            ]
        }
    };
    loadMSO.value = false;
    d1.value++;
    d2.value++;
    d3.value++;
    d4.value++;
    d5.value++;
    d6.value++;
    d7.value++;
    d8.value++;
    d9.value++;
    d10.value++;
    d11.value++;
  } catch (error) {
    console.log(error.message);
  }*/

};
getMemberDonutChartStats()

const getMemberStackBarChartStats = () => {
  const param = getParams();
  try {
    loadFollowResult.value = true;
    axios.post(`${process.env.VUE_APP_BASE_API}member/getMemberStackBarChartStats`, param)
    .then((response) => {

      // console.log(response.data);
      // set data label
      var data = response.data;
      amount_health.value = data.prob_health.survivable + data.prob_health.sufficient + data.prob_health.sustainable + data.prob_health.not_proceeded;
      amount_family.value = data.prob_family.survivable + data.prob_family.sufficient + data.prob_family.sustainable + data.prob_family.not_proceeded;
      amount_education.value = data.prob_education.survivable + data.prob_education.sufficient + data.prob_education.sustainable + data.prob_education.not_proceeded;
      amount_occupation.value = data.prob_occupation.survivable + data.prob_occupation.sufficient + data.prob_occupation.sustainable + data.prob_occupation.not_proceeded;
      amount_accessibility.value = data.prob_accessibility.survivable + data.prob_accessibility.sufficient + data.prob_accessibility.sustainable + data.prob_accessibility.not_proceeded;

      var amount_total = amount_health.value + amount_family.value + amount_education.value + amount_occupation.value + amount_accessibility.value;
      var amount_percent = amount_total / 100;

      if(amount_percent > 0){
        ratio_health.value = amount_health.value / amount_percent;
        ratio_family.value = amount_family.value / amount_percent;
        ratio_education.value = amount_education.value / amount_percent;
        ratio_occupation.value = amount_occupation.value / amount_percent;
        ratio_accessibility.value = amount_accessibility.value / amount_percent;
      }else{
        ratio_health.value = 0;
        ratio_family.value = 0;
        ratio_education.value = 0;
        ratio_occupation.value = 0;
        ratio_accessibility.value = 0;
      }

      loadFollowResult.value = false;
      resultImport.value = response.data;
      dimFollowResultKey.value++;

    })
  } catch (error) {
    console.log(error.message);
  }
};
getMemberStackBarChartStats()

const getMemberStackBarChartActionStats = () => {
  const param = getParams();
  try {
    loadFollowStatus.value = true;
    axios.post(`${process.env.VUE_APP_BASE_API}member/getMemberStackBarChartActionStats`, param)
    .then((response) => {
      // console.log(response.data);
      loadFollowStatus.value = false;
      statusImport.value = response.data;
      dimFollowStatusKey.value++;
    })
  } catch (error) {
    console.log(error.message);
  }
};
getMemberStackBarChartActionStats()

const getMemberStackBarChartAgeClassStats = () => {
  const param = getParams();
  try {
    loadFollowAge.value = true;
    axios.post(`${process.env.VUE_APP_BASE_API}member/getMemberStackBarChartAgeClassStats`, param)
    .then((response) => {
      // console.log(response.data);

      // set data label
      var data = response.data;
      amount_youngchild.value = data.youngchild.planned + data.youngchild.helped + data.youngchild.closed + data.youngchild.not_proceeded;
      amount_child.value = data.child.planned + data.child.helped + data.child.closed + data.child.not_proceeded;
      amount_adolescence.value = data.adolescence.planned + data.adolescence.helped + data.adolescence.closed + data.adolescence.not_proceeded;
      amount_adult.value = data.adult.planned + data.adult.helped + data.adult.closed + data.adult.not_proceeded;
      amount_elderly.value = data.elderly.planned + data.elderly.helped + data.elderly.closed + data.elderly.not_proceeded;

      var amount_total = amount_youngchild.value + amount_child.value + amount_adolescence.value + amount_adult.value + amount_elderly.value;
      var amount_percent = amount_total / 100;

      if(amount_percent > 0){
        ratio_youngchild.value = amount_youngchild.value / amount_percent;
        ratio_child.value = amount_child.value / amount_percent;
        ratio_adolescence.value = amount_adolescence.value / amount_percent;
        ratio_adult.value = amount_adult.value / amount_percent;
        ratio_elderly.value = amount_elderly.value / amount_percent;
      }else{
        ratio_youngchild.value = 0;
        ratio_child.value = 0;
        ratio_adolescence.value = 0;
        ratio_adult.value = 0;
        ratio_elderly.value = 0;
      }

      loadFollowAge.value = false;
      ageRangeImport.value = response.data;
      dimFollowAgeRangeKey.value++;

    })
  } catch (error) {
    console.log(error.message);
  }
};
getMemberStackBarChartAgeClassStats()
// end api

</script>

<style lang="scss" scoped>
input[type="radio"] {
  display: none;
}

#mso_11_prov::-webkit-scrollbar {
  padding-top: 10px;
  height: 5px;
}

#mso_11_prov::-webkit-scrollbar-track {
  background: none;
}

#mso_11_prov::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  transition: all 0.2s ease;
}

#mso_11_prov::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.4);
}

.box-shadow {
  box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
}

.vs__dropdown-toggle {
  background: #FFF;
}

.vs__search {
  font-size: 0.75rem;
}
</style>
